
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxTertiaryButtonProps {
  handleClose: () => void;
  label?: string;
  saved?: boolean;
}
const GxSaveChanges: React.FC<GxTertiaryButtonProps> = ({
  handleClose,
  label = "Save changes",
  saved = false,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      onClick={handleClose}
      className="gx-dialog-savechanges-button gx-p12-eb"
    >
      <span className="gx-p12-eb">
        {saved ? t("Saved!") : t(label)}
      </span>
    </Button>
  );
};

export default GxSaveChanges;
